import React from 'react'
import { reduxForm, Field } from 'redux-form'
import PropTypes from 'prop-types'

import {
  formContainer,
  titleContainer,
  mainTitle,
  buttonContainer
} from './styles/LoginForm.style'

import { Button } from '../shared/styles/Button.style'
import Input from '../shared/Input'

import * as validators from '../../utils/validators'

const ChangePasswordForm = ({ handleSubmit, onSubmit, translation, lang }) => {
  const required = lang === 'pt-BR' ? validators.requiredPT : validators.requiredES
  const passwordLength = lang === 'pt-BR' ? validators.passwordLengthPT : validators.passwordLengthES
  const passwordConfirmation = lang === 'pt-BR' ? validators.passwordConfirmatioPT : validators.passwordConfirmatioES
  return (
    <form className={formContainer} onSubmit={handleSubmit(onSubmit)}>
      <header className={titleContainer}>
        <h1 className={mainTitle}>{translation('changePasswordForm')['passwordFormTitle']}</h1>
      </header>

      <div>
        <Field
          name='password'
          placeholder={translation('changePasswordForm')['newPasswordPlaceholder']}
          type='password'
          block
          validate={[required, passwordLength]}
          component={Input}
        />

        <Field
          name='password_confirmation'
          placeholder={translation('changePasswordForm')['confirmPasswordPlaceholder']}
          type='password'
          block
          validate={[required, passwordConfirmation]}
          component={Input}
        />
      </div>

      <div className={buttonContainer}>
        <Button
          type='submit'
        >
          {translation('changePasswordForm')['changeButton']}
        </Button>
      </div>
    </form>
  )
}

ChangePasswordForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  translation: PropTypes.func,
  lang: PropTypes.string
}

export default reduxForm({
  form: 'changePassoword'
})(ChangePasswordForm)
